/* eslint-disable */
/**
 * 根容器  用于继承
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import Cookies from 'js-cookie';
import { translate as t } from '_common/utils/language';
import { FormErrorType, FormType } from '../FormType';

export default class ItemContext extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  /**
   * 获取焦点事件
   */
  onFocus = (e) => {
    const val = e && e.target !== undefined ? e.target.value : e;
    const { key, formType, onFocus, extend } = this.props.dataSource;
    this.setState({
      dataError: false,
      focus: true,
    });
    onFocus && onFocus(key, formType, val, extend);
  };

  /**
   *
   * @param e
   * @param delay 延时
   */
  onBlur = (e, delay) => {
    const { errorMsg } = this.state;
    const { key, formType, onBlur, extend } = this.props.dataSource;

    if (delay && delay > 0) {
      setTimeout(() => {
        this.setState({
          dataError: errorMsg.length !== 0,
          focus: false,
        });
      }, delay);
    } else {
      this.setState({
        dataError: errorMsg.length !== 0,
        focus: false,
      });
    }
    const val = e && e.target !== undefined ? e.target.value : e;
    onBlur && onBlur(key, formType, val, extend);
  };

  /**
   * 强制赋值
   * @param dataSource
   */
  setValue = (dataSource) => {
    const {
      key,
      formType,
      extend,
      value,
      errorData,
      onValSetFinished,
      onErrorCleaned,
      onErrorSetFinished,
      forceMode,
    } = dataSource;

    // 强制模式 值相同的情况下 不触发逻辑
    if (forceMode && this.state.value === value) {
      return;
    }
    if (value !== '' && value !== null && value !== undefined) {
      // 强制赋值的同时也应该判断errorMsg
      const errorMsg = this.getErrorMsg(value, errorData);
      this.setState({
        value,
        errorMsg,
      });
      onValSetFinished && onValSetFinished(key, formType, extend);

      // 如果新的值没有错误 则通知外部清理错误，否则通知外部
      if (errorMsg.length === 0) {
        onErrorCleaned && onErrorCleaned(key, formType, extend);
      } else {
        onErrorSetFinished && onErrorSetFinished(key, formType, extend);
      }
    }
  };

  /**
   * 强制设置错误后的回调
   * 与 error对象对应使用 用于设置完之后通知外部 清除掉错误
   * @param dataSource
   */
  setError = (dataSource) => {
    const { key, formType, onChange, extend, error, onErrorSetFinished } =
      dataSource;

    if (error) {
      this.setState({
        errorMsg: error.msg,
        dataError: true,
      });
      onErrorSetFinished && onErrorSetFinished(key, formType, extend);
      onChange && onChange(key, formType, this.state.value, false, extend);
    }
  };

  /**
   * 获取 错误信息
   * @param val 值
   * @param errorData  传入的用于校验的错误数据
   * @returns {string} 返回错误提示
   */
  getErrorMsg = (val, errorData) => {
    if (!errorData) {
      return '';
    }
    const { key, title } = this.props.dataSource;
    let errorMsg = '';
    for (let i = 0; i < errorData.length; i++) {
      if (errorMsg.length !== 0) {
        break;
      }
      const item = errorData[i];
      switch (item.type) {
        // 空校验
        case FormErrorType.NULL:
          if (!val || val.length === 0) {
            errorMsg =
              Cookies.get('locale') === 'ja_JP'
                ? `${title}${t('check.input')}`
                : Cookies.get('locale') === 'zh_CN' ||
                  Cookies.get('locale') === 'zh_HK'
                ? `${t('tip.enter')}${title}`
                : `${t('tip.enter')} ${title}`;
          }
          break;
        // 超长校验
        case FormErrorType.OVER_LENGTH:
          if (val && item.maxLength && val.length > Number(item.maxLength)) {
            errorMsg = t('tips.overMaxLength.cardName');
          }
          break;
        case FormErrorType.OVER_LENGTH:
          if (val && item.maxLength && val.length > Number(item.maxLength)) {
            errorMsg = t('tips.overMaxLength');
          }
          break;
        // 其他校验，请给自己带盐：带表达式、带错误信息
        case FormErrorType.OTHER:
          if (item.checkError) {
            if (item.checkError(val, key)) {
              errorMsg = item.msg;
            }
          } else if (item.checkErrors) {
            const check = item.checkErrors(val, key);
            if (check.result) {
              errorMsg = check.msg;
            }
          }
          break;
        default:
          break;
      }
    }
    return errorMsg;
  };

  /**
   * 强制清除错误
   * 与 cleanError 对应使用 用于设置完之后通知外部 已清除错误
   * @param dataSource
   */
  cleanError = (dataSource) => {
    const {
      key,
      formType,
      onChange,
      extend,
      errorData,
      cleanError,
      onErrorCleaned,
    } = dataSource;

    if (this.state.errorMsg && this.state.errorMsg.length === 0) {
      return;
    }
    if (cleanError) {
      this.setState({
        errorMsg: '',
        dataError: false,
      });
      onErrorCleaned && onErrorCleaned(key, formType, extend);
      const hasError =
        this.getErrorMsg(this.state.value, errorData).length === 0;
      onChange && onChange(key, formType, this.state.value, hasError, extend);
    }
  };

  /**
   * 强制清除值
   * 与 cleanValue 对应使用 用于设置完之后通知外部 已清除错误
   * @param dataSource
   */
  cleanValue = (dataSource) => {
    const {
      key,
      formType,
      onChange,
      extend,
      errorData,
      inputList,
      cleanValue,
      onValueCleaned,
    } = dataSource;

    if (cleanValue) {
      if (formType === FormType.MULTI_INPUT) {
        // 如果是多类型输入框，单独处理清空操作
        const multiValue = [];
        inputList.forEach(() => {
          multiValue.push('');
        });
        this.setState({ multiValue });
      } else {
        this.setState({
          value: '',
        });
      }

      onValueCleaned && onValueCleaned(key, formType, extend);
      // const hasError = this.getErrorMsg(this.state.value, errorData).length === 0;

      if (formType === FormType.MULTI_INPUT) {
        onChange && onChange(key, formType, '', false, extend, undefined);
      } else {
        onChange && onChange(key, formType, undefined, false, extend);
      }
    }
  };
}
